/**
 * GSAP ScrollTrigger Animations for AIVIQ
 */

(function () {
  // Register ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Default Animation Settings
  const defaultSettings = {
    duration: 1,
    ease: "power3.out",
    y: 50,
    opacity: 0,
    stagger: 0.1
  };

  /**
   * Initialize Global Animations
   * Scans for elements with specific classes and applies animations
   */
  function initAnimations() {

    // GSAP ScrollTrigger Parallax (Mimic Locomotive data-scroll)
    const parallaxElements = document.querySelectorAll('[data-scroll]');
    parallaxElements.forEach(el => {
      const speed = el.getAttribute('data-scroll-speed');
      const scrollClass = el.getAttribute('data-scroll-class');

      // If data-scroll-speed is present, apply parallax
      if (speed) {
        gsap.to(el, {
          y: (i, target) => {
            return (parseFloat(speed) * 100) + 'px';
          },
          ease: "none",
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom top",
            scrub: 0,
            markers: false
          }
        });
      }

      // If data-scroll-class is present, toggle it
      if (scrollClass) {
        ScrollTrigger.create({
          trigger: el,
          start: "top 80%",
          end: "bottom 20%",
          toggleClass: { targets: el, className: scrollClass },
          markers: false
        });
      }
    });

    // Fade Up Animation (.gsap-fade-up)
    const fadeUpElements = document.querySelectorAll('.gsap-fade-up');
    fadeUpElements.forEach(el => {
      gsap.fromTo(el,
        {
          y: 60,
          opacity: 0,
          scale: 0.98
        },
        {
          scrollTrigger: {
            trigger: el,
            start: "top 90%",
            toggleActions: "play none none reverse"
          },
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1.1,
          ease: "power3.out"
        }
      );
    });

    // Reveal Animation (.gsap-reveal)
    const revealElements = document.querySelectorAll('.gsap-reveal');
    revealElements.forEach(el => {
      gsap.fromTo(el,
        { clipPath: "inset(0 0 100% 0)", opacity: 0 },
        {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none reverse"
          },
          clipPath: "inset(0 0 0% 0)",
          opacity: 1,
          duration: 1.4,
          ease: "expo.out"
        }
      );
    });

    // Staggered Child Animation (.gsap-stagger-children)
    const staggerContainers = document.querySelectorAll('.gsap-stagger-children');
    staggerContainers.forEach(container => {
      const children = container.children;
      gsap.fromTo(children,
        { y: 40, opacity: 0 },
        {
          scrollTrigger: {
            trigger: container,
            start: "top 85%",
            toggleActions: "play none none reverse"
          },
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: "power2.out"
        }
      );
    });

    console.log("✅ GSAP Animations Initialized");
  }

  // Refresh ScrollTrigger on Lenis scroll (optional but recommended if using pin)
  // Since we are using standard ScrollTrigger with Lenis, it usually works out of box 
  // if Lenis is normalizing wheel or we just let ScrollTrigger hook into native scroll.
  // We just need to make sure ScrollTrigger updates on DOM changes.

  // Initialize on load
  if (document.readyState === "complete" || document.readyState === "interactive") {
    initAnimations();
  } else {
    document.addEventListener("DOMContentLoaded", initAnimations);
  }

  // Re-init on Shopify Section Load (for Theme Editor)
  document.addEventListener("shopify:section:load", initAnimations);

})();
